module.exports = new __parcel__URL__("lune-voile.44a915df.svg").toString();